import { cva } from "class-variance-authority";
import { cn } from "../../../@shadcn/lib/utils";
import { UPIIntentMethodType } from "../types";

const iconWrapperVariants = cva("ui-rounded-lg ui-h-10 ui-w-10 ui-relative", {
  variants: {
    isLoading: {
      true: "upiLogo-loader ui-cursor-not-allowed",
      false: "",
    },
  },
  defaultVariants: {
    isLoading: false,
  },
});

export const MethodLogo: React.FC<UPIIntentMethodType> = ({
  id,
  logo,
  name,
  offerText,
  isLoading = false,
  iconClassname,
}) => {
  return (
    <div
      className="ui-flex ui-cursor-pointer ui-gap-1.5 ui-flex-col ui-items-center ui-space-y-4"
      data-app-id={id}
    >
      <div className={cn(iconWrapperVariants({ isLoading }), iconClassname)}>
        {offerText && (
          <span className="ui-absolute -ui-top-1 ui-left-1/2 ui-z-10 -ui-translate-x-1/2 -ui-translate-y-1/2 ui-whitespace-nowrap ui-rounded-md ui-bg-gradient-to-r ui-from-emerald-100 ui-to-white ui-px-1 ui-py-0.5 ui-text-[9px] ui-font-semibold ui-text-emerald-600 ui-shadow-sm">
            {offerText}
          </span>
        )}
        <img
          src={logo}
          alt={name}
          className="ui-h-full ui-w-full ui-rounded ui-object-contain"
        />
      </div>
      <p className="ui-text-xxs ui-font-medium ui-capitalize !ui-mt-0 ui-opacity-[70%]">
        {name}
      </p>
    </div>
  );
};
